import { create } from 'zustand';

interface UseTextFieldStore {
  text: string;
  fontSize: number;
  fontStyle: 'normal' | 'italic' | 'oblique';
  fontWeight: 'normal' | 'bold' | 'bolder' | 'lighter' | number;
  fill: string;
  textAlign: 'left' | 'center' | 'right' | 'start' | 'end';
  position: {
    x: number;
    y: number;
  };

  updateText: (newText: string) => void;
  updateStyle: (
    style: Partial<
      Omit<UseTextFieldStore, 'updateText' | 'updateStyle' | 'updatePosition'>
    >
  ) => void;
  updatePosition: (position: { x: number; y: number }) => void;
}

export const useTextFieldStore = create<UseTextFieldStore>((set) => ({
  text: 'Edit me',
  fontSize: 20,
  fontStyle: 'normal',
  fontWeight: 'normal',
  fill: '#000000',
  textAlign: 'left',
  position: { x: 100, y: 100 },

  updateText: (newText) => set({ text: newText }),
  updateStyle: (style) => set((state) => ({ ...state, ...style })),
  updatePosition: (position) => set({ position }),
}));
